<template>
  <div>
    <v-chart :forceFit="true" :height="height" :data="data" padding="auto" :scale='scale'>
      <v-tooltip :showTitle="false" dataKey="value" ></v-tooltip>
      <v-legend />
      <v-coord type="theta" :radius="0.6" />
      <v-stack-bar position="value" :color="color" :style="style"  :label="labelConfig"/>
    </v-chart>
  </div>
</template>

<script>
const color = ['item', ['#3AA1FF', '#55CE79', '#FCD540', '#9B66E6', '#3FCECE', '#677BCB', '#DB8E52', '#D470A9', '#BCC33E', '#9438EF', '#D324B6','#5356DD','#F16552','#49AEBE']]


const style = {
  stroke: 'white',
  lineWidth: 1
}

export default {
  props: {
    data: {
      type: Array,
      default:[30],
    },
    scale:{
        type: Array
    },
    height:{
      type:String,
      default:'380'
    }
  },
  data() {
    return {
      color,
      style,
    // labelConfig: ['value', {
    //     offset: -40,
    //     textStyle: {
    //       rotate: 0,
    //       textAlign: 'center',
    //       shadowBlur: 2,
    //       shadowColor: 'rgba(0, 0, 0, .45)'
    //     },
    //       formatter: (val, item) => {
    //         console.log(item)
    //         return item.point.item + ': ' + item.point.value;
    //       }
    //   }],
        labelConfig: ['value', function(val,item) {
          var offset = parseInt(item._origin.percentage)<5?50:15;
          return {
          offset:offset,
          formatter: (val, item) => {
            return offset==15?item.point.item + '\n' +  item.point.percentage:item.point.item + ' ' +  item.point.percentage ;
          }
        }
        }],
    }
  }
}
</script>